import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Dialog, DialogActionsBar  } from '@progress/kendo-react-dialogs';
//import { Parser } from 'html-to-react';


interface ISystemPopup {
    popupWidth?: any,
    className: string,
    popupHeight?: any,
    popupTitle?: string,
    btnTitle?: string,
    children?: any
    showButton?: boolean
}

interface ISystemDialogProps {
    title?: any;
    onYes?(): void;
    onNo?(): void;
    onAbort?(): void;
    onCancel?(): void;
    onClose?(): void;
    message?: string
    visible: boolean
    isHtml?: boolean
    showActionButton?: boolean
    showYes?: boolean
    showNo?: boolean
    showCancel?: boolean
    showAbort?: boolean
    showClose?: boolean
}

export default class SystemDialog<T extends ISystemDialogProps> extends React.Component<T> {
    static defaultProps = {
        showYes: true,
        showNo: true,
        showCancel: false,
        showAbort: false,
        showClose: false
    }

    onYes = () => this.props.onYes && this.props.onYes();
    onAbort = () => this.props.onAbort && this.props.onAbort();
    onNo = () => this.props.onNo && this.props.onNo();
    onCancel = () => this.props.onCancel && this.props.onCancel();
    onClose = () => this.props.onClose && this.props.onClose();
    


    render() {
        return (
            <div>
                {
                    this.props.visible &&
                    <Dialog title={this.props.title || "Please confirm"} onClose={this.onNo}>
                        {this.props.isHtml ? <p style={{ margin: "25px", maxHeight: "600px" }}>{ Parser().parse(this.props.message) }</p>
                            : <p style={{ margin: "25px", textAlign: "center" }}>{ this.props.message}</p>
                        }

                        {!this.props.isHtml && <DialogActionsBar>
                            <div className="system_popup_btn">
                                {this.props.showYes && <button className="k-button" onClick={this.onYes}>Yes</button>}
                                {this.props.showNo && <button className="k-button" onClick={this.onNo}>No</button>}
                                {this.props.showCancel && <button className="k-button" onClick={this.onCancel}>Cancel</button>}
                                {this.props.showAbort && <button className="k-button" onClick={this.onAbort}>Abort</button>}
                                {this.props.showClose && <button className="k-button" onClick={this.onClose}>Close</button>}
                            </div>
                        </DialogActionsBar>}
                    </Dialog>}
            </div>
        );
    }
}